/*
Accepted Values: 'dxAutocomplete' | 'dxCalendar' | 'dxCheckBox' | 'dxColorBox' | 'dxDateBox' | 'dxDropDownBox' | 'dxHtmlEditor' | 'dxLookup' | 'dxNumberBox' | 'dxRadioGroup' | 'dxRangeSlider' | 'dxSelectBox' | 'dxSlider' | 'dxSwitch' | 'dxTagBox' | 'dxTextArea' | 'dxTextBox'
*/

import { Component, Input, OnInit } from '@angular/core';
export class SimpleObject {
  value: number | string;

  name: string;

  icon?: string;

  badge?: string;
}

export class Alignment {
  icon: string;
  alignment: string;
  location: string;
  hint: string;
}

@Component({
  selector: 'app-edit-search',
  templateUrl: './edit-search.component.html',
  styleUrls: ['./edit-search.component.css']
})
export class EditSearchComponent implements OnInit {
  @Input() labelKey: string = '';
  @Input() editor_Type:string='dxTextBox'
 // editorType='dxDateBox'
 selectBoxOptions = {
  width: 140,
  items: ['All', 'Family', 'Favorites'],
  onItemClick: function(e) {
      // ...
  }
};
alignments: SimpleObject[] = [
  { value: 'left', name: 'Left', icon: 'alignleft' },
  { value: 'right', name: 'Right', icon: 'alignright' },
  { value: 'center', name: 'Center', icon: 'aligncenter' },
  { value: 'justify', name: 'Justify', icon: 'alignjustify' },
];

 downloads = ['Download Trial For Visual Studio', 'Download Trial For All Platforms', 'Package Managers'];

 phoneOptions= {
    buttons: [    
      {
      name: 'trash',
      location: 'after',
      options: {
       // stylingMode: 'text',
        icon: 'user',
        onClick: () => {
          //this.employee.Phones.splice(index, 1);
          //this.phoneOptions = this.getPhonesOptions(this.employee.Phones);
        },
      },
    },
    {
      name: 'trashw',
      location: 'before',
      options: {
       // stylingMode: 'text',
        icon: 'user',
        onClick: () => {
          //this.employee.Phones.splice(index, 1);
          //this.phoneOptions = this.getPhonesOptions(this.employee.Phones);
        },
      },
    },
  ],
  };



 passwordOptions: any = {
  mode: 'password',
  onValueChanged: () => {
    /*
    let editor = this.form.instance.getEditor('ConfirmPassword');
    if (editor.option('value')) {
      let instance = Validator.getInstance(editor.element()) as Validator;
      instance.validate();
    }*/
  },
  buttons: [
    {
      name: 'password',
      location: 'after',
      options: {
        icon: 'images/icons/eye.png',
        type: 'default',
       // onClick: () => this.changePasswordMode('Password'),
      },
    },
  ],
};



  constructor() { }

  ngOnInit() {
  }

}
